type wlProgressDataMemberType = {
   date: Date,
   weight: number,
   cheatDay?: boolean
}

type pictureMapType = {
	[key: string]: string
};


const wlProgressData: wlProgressDataMemberType[] = [
/* {
   "date": new Date('2019-02-03'),
   "weight": 219,
 },
 {
   "date": new Date('2019-02-16'),
   "weight": 215,
 },*/
 /*{
   "date": new Date('2019/10/03'),
   "weight": 208.6,
 },*/
 {
   "date": new Date('2019/10/05'),
   "weight": 208.6,
 },
 {
   "date": new Date('2019/10/08'),
   "weight": 207.4,
 },
 {
   "date": new Date('2019/10/10'),
   "weight": 204.6,
 },
 {
   "date": new Date('2019/10/11'),
   "weight": 203.8,
 },
 {
   "date": new Date('2019/10/12'),
   "weight": 203,
 },
 {
   "date": new Date('2019/10/13'),
   "weight": 202.4,
 },
 {
   "date": new Date('2019/10/14'),
   "weight": 203.2,
 },
 {
   "date": new Date('2019/10/15'),
   "weight": 203,
 },
 {
   "date": new Date('2019/10/16'),
   "weight": 203.4,
 },
 {
   "date": new Date('2019/10/17'),
   "weight": 200.8,
 },
 {
   "date": new Date('2019/10/18'),
   "weight": 200.6,
 },
 {
   "date": new Date('2019/10/19'),
   "weight": 200.4,
 },
 {
   "date": new Date('2019/10/20'),
   "weight": 199.4,
 },
 {
   "date": new Date('2019/10/21'),
   "weight": 198,
 },
 {
   "date": new Date('2019/10/22'),
   "weight": 198.4,
 },
 {
   "date": new Date('2019/10/23'),
   "weight": 196.8,
 },
 {
   "date": new Date('2019/10/24'),
   "weight": 198.4,
 },
 {
   "date": new Date('2019/10/25'),
   "weight": 197.8,
 },
 {
   "date": new Date('2019/10/26'),
   "weight": 197,
 },
 {
   "date": new Date('2019/10/27'),
   "weight": 197.8,
   "cheatDay": true,
 },
 {
   "date": new Date('2019/10/28'),
   "weight": 199.2,
 },
 {
   "date": new Date('2019/10/29'),
   "weight": 198.4,
 },
 {
   "date": new Date('2019/10/30'),
   "weight": 197,
 },
 {
   "date": new Date('2019/10/31'),
   "weight": 194.2,
 },
 {
   "date": new Date('2019/11/01'),
   "weight": 194.4,
 },
 {
   "date": new Date('2019/11/02'),
   "weight": 195.4,
 },
 {
   "date": new Date('2019/11/03'),
   "weight": 194.8,
 },
 {
   "date": new Date('2019/11/04'),
   "weight": 194.4,
 },
 {
   "date": new Date('2019/11/05'),
   "weight": 195,
 },
 {
   "date": new Date('2019/11/06'),
   "weight": 193.8,
 },
 {
   "date": new Date('2019/11/07'),
   "weight": 193,
 },
 {
   "date": new Date('2019/11/08'),
   "weight": 192,
 },
 {
   "date": new Date('2019/11/09'),
   "weight": 191.2,
 },
 {
   "date": new Date('2019/11/10'),
   "weight": 191.4,
 },
 {
   "date": new Date('2019/11/11'),
   "weight": 192,
 },
 {
   "date": new Date('2019/11/12'),
   "weight": 191,
 },
 {
   "date": new Date('2019/11/13'),
   "weight": 191.4,
 },
 {
   "date": new Date('2019/11/14'),
   "weight": 188.8,
 },
 {
   "date": new Date('2019/11/15'),
   "weight": 188.8,
   "cheatDay": true,
 },
 {
   "date": new Date('2019/11/16'),
   "weight": 190.2,
   "cheatDay": true,
 },
 {
   "date": new Date('2019/11/17'),
   "weight": 191.6,
 },
 {
   "date": new Date('2019/11/18'),
   "weight": 190.8,
 },
 {
   "date": new Date('2019/11/19'),
   "weight": 192.8,
 },
 {
   "date": new Date('2019/11/20'),
   "weight": 192,
 },
 {
   "date": new Date('2019/11/21'),
   "weight": 190.4,
 },
 {
   "date": new Date('2019/11/22'),
   "weight": 189.4,
 },
 {
   "date": new Date('2019/11/23'),
   "weight": 190,
 },
 {
   "date": new Date('2019/11/24'),
   "weight": 186.8,
 },
 {
   "date": new Date('2019/11/25'),
   "weight": 186.8,
 },
 {
   "date": new Date('2019/11/26'),
   "weight": 187.8,
 },
 {
   "date": new Date('2019/11/27'),
   "weight": 188,
   "cheatDay": true,
 },
 {
   "date": new Date('2019/11/28'),
   "weight": 189.2,
 },
 {
   "date": new Date('2019/11/29'),
   "weight": 190,
 },
 {
   "date": new Date('2019/11/30'),
   "weight": 189.8,
 },
 {
   "date": new Date('2019/12/01'),
   "weight": 189.6,
 },
 {
   "date": new Date('2019/12/02'),
   "weight": 191,
 },
 {
   "date": new Date('2019/12/03'),
   "weight": 190.8,
 },
 {
   "date": new Date('2019/12/04'),
   "weight": 187.2,
 },
 {
   "date": new Date('2019/12/05'),
   "weight": 185.8,
 },
 {
   "date": new Date('2019/12/06'),
   "weight": 184.6,
 },
 {
   "date": new Date('2019/12/07'),
   "weight": 185.6,
 },
 {
   "date": new Date('2019/12/08'),
   "weight": 185.4,
 },
 {
   "date": new Date('2019/12/09'),
   "weight": 186.2,
 },
 {
   "date": new Date('2019/12/10'),
   "weight": 185.6,
 },
 {
   "date": new Date('2019/12/11'),
   "weight": 183.8,
 },
 {
   "date": new Date('2019/12/12'),
   "weight": 185.2,
 },
 {
   "date": new Date('2019/12/13'),
   "weight": 183.8,
 },
 {
   "date": new Date('2019/12/14'),
   "weight": 183.2,
 },
 {
   "date": new Date('2019/12/15'),
   "weight": 181.6,
 },
 {
   "date": new Date('2019/12/16'),
   "weight": 182.8,
 },
 {
   "date": new Date('2019/12/17'),
   "weight": 182.4,
 },
 {
   "date": new Date('2019/12/18'),
   "weight": 182.2,
 },
 {
   "date": new Date('2019/12/19'),
   "weight": 180.4,
 },
 {
   "date": new Date('2019/12/20'),
   "weight": 177.8,
 },
 {
   "date": new Date('2019/12/21'),
   "weight": 180.4,
   "cheatDay": true,
 },
 {
   "date": new Date('2019/12/22'),
   "weight": 183.8,
 },
 {
   "date": new Date('2019/12/23'),
   "weight": 184,
 },
 {
   "date": new Date('2019/12/24'),
   "weight": 182,
 },
 {
   "date": new Date('2019/12/25'),
   "weight": 180,
 },
 {
   "date": new Date('2019/12/26'),
   "weight": 181.4,
 },
 {
   "date": new Date('2019/12/27'),
   "weight": 180.4,
 },
 {
   "date": new Date('2019/12/28'),
   "weight": 179.8,
 },
 {
   "date": new Date('2019/12/29'),
   "weight": 180.8,
   "cheatDay": true,
 },
 {
   "date": new Date('2019/12/30'),
   "weight": 183.4,
 },
 {
   "date": new Date('2019/12/31'),
   "weight": 182.6,
 },
 {
   "date": new Date('2020/01/01'),
   "weight": 185.8,
 },
 {
   "date": new Date('2020/01/02'),
   "weight": 183.2,
 },
 {
   "date": new Date('2020/01/03'),
   "weight": 181,
 },
 {
   "date": new Date('2020/01/04'),
   "weight": 180,
 },
 {
   "date": new Date('2020/01/05'),
   "weight": 180.4,
 },
 {
   "date": new Date('2020/01/06'),
   "weight": 179.6,
 },
 {
   "date": new Date('2020/01/07'),
   "weight": 181.2,
 },
 {
   "date": new Date('2020/01/08'),
   "weight": 180.2,
 },
 {
   "date": new Date('2020/01/09'),
   "weight": 178.2,
 },
 {
   "date": new Date('2020/01/10'),
   "weight": 178,
 },
 {
   "date": new Date('2020/01/11'),
   "weight": 177.8,
 },
 {
   "date": new Date('2020/01/12'),
   "weight": 178.2,
 },
 {
   "date": new Date('2020/01/13'),
   "weight": 181,
 },
 {
   "date": new Date('2020/01/14'),
   "weight": 182.6,
 },
 {
   "date": new Date('2020/01/15'),
   "weight": 182.8,
 },
 {
   "date": new Date('2020/01/16'),
   "weight": 179,
 },
 {
   "date": new Date('2020/01/17'),
   "weight": 179,
 },
 {
   "date": new Date('2020/01/18'),
   "weight": 178,
 },
 {
   "date": new Date('2020/01/19'),
   "weight": 177.2,
 },
 {
   "date": new Date('2020/01/20'),
   "weight": 176.6,
 },
 {
   "date": new Date('2020/01/21'),
   "weight": 179.6,
   "cheatDay": true,
 },
 {
   "date": new Date('2020/01/22'),
   "weight": 180,
   "cheatDay": true,
 },
 {
   "date": new Date('2020/01/23'),
   "weight": 179.2,
 },
 {
   "date": new Date('2020/01/24'),
   "weight": 177.6,
   "cheatDay": true,
 },
 {
   "date": new Date('2020/01/25'),
   "weight": 181.2,
   "cheatDay": true,
 },
 {
   "date": new Date('2020/01/26'),
   "weight": 181.8,
 },
 {
   "date": new Date('2020/01/27'),
   "weight": 179.6,
 },
 {
   "date": new Date('2020/01/28'),
   "weight": 180.8,
 },
 {
   "date": new Date('2020/01/29'),
   "weight": 178.4,
 },
 {
   "date": new Date('2020/01/30'),
   "weight": 177.4,
 },
 {
   "date": new Date('2020/01/31'),
   "weight": 176.8,
   "cheatDay": true,
 },
 {
   "date": new Date('2020/02/01'),
   "weight": 178.4,
   "cheatDay": true,
 },
 {
   "date": new Date('2020/02/02'),
   "weight": 181.2,
   "cheatDay": true,
 },
 {
   "date": new Date('2020/02/03'),
   "weight": 181.8,
 },
 {
   "date": new Date('2020/02/04'),
   "weight": 179.4,
 },
 {
   "date": new Date('2020/02/05'),
   "weight": 177,
   "cheatDay": true,
 },
 {
   "date": new Date('2020/02/06'),
   "weight": 179.2,
   "cheatDay": true,
 },
 {
   "date": new Date('2020/02/07'),
   "weight": 179.2,
   "cheatDay": true,
 },
 {
   "date": new Date('2020/02/08'),
   "weight": 179,
   "cheatDay": true,
 },
 {
   "date": new Date('2020/02/09'),
   "weight": 179.2,
 },
 {
   "date": new Date('2020/02/10'),
   "weight": 176,
 },
 {
   "date": new Date('2020/02/11'),
   "weight": 177.4,
 },
 {
   "date": new Date('2020/02/12'),
   "weight": 177,
 },
 {
   "date": new Date('2020/02/13'),
   "weight": 176.6,
 },
 {
   "date": new Date('2020/02/14'),
   "weight": 177.2,
   "cheatDay": true,
 },
 {
   "date": new Date('2020/02/15'),
   "weight": 176.2,
   "cheatDay": true,
 },
 {
   "date": new Date('2020/02/16'),
   "weight": 178.2,
   "cheatDay": true,
 },
 {
   "date": new Date('2020/02/17'),
   "weight": 178,
   "cheatDay": true,
 },
 {
   "date": new Date('2020/02/18'),
   "weight": 178.4,
   "cheatDay": true,
 },
 {
   "date": new Date('2020/02/19'),
   "weight": 180.6,
 },
 {
   "date": new Date('2020/02/20'),
   "weight": 179.4,
 },
 {
   "date": new Date('2020/02/21'),
   "weight": 177.6,
 },
 {
   "date": new Date('2020/02/22'),
   "weight": 176.4,
 },
 {
   "date": new Date('2020/02/23'),
   "weight": 175.4,
 },
 {
   "date": new Date('2020/02/24'),
   "weight": 175,
 },
 {
   "date": new Date('2020/02/25'),
   "weight": 177.2,
 },
 {
   "date": new Date('2020/02/26'),
   "weight": 176.2,
 },
 {
   "date": new Date('2020/02/27'),
   "weight": 174.6,
 },
 {
   "date": new Date('2020/02/28'),
   "weight": 174.4,
   "cheatDay": true,
 },
 {
   "date": new Date('2020/02/29'),
   "weight": 175.6,
   "cheatDay": true,
 },
 {
   "date": new Date('2020/03/01'),
   "weight": 174.8,
   "cheatDay": true,
 },
 {
   "date": new Date('2020/03/02'),
   "weight": 176.6,
   "cheatDay": true,
 },
 {
   "date": new Date('2020/03/03'),
   "weight": 177.8,
 },
 {
   "date": new Date('2020/03/04'),
   "weight": 178.4,
 },
 {
   "date": new Date('2020/03/05'),
   "weight": 176.6,
 },
 {
   "date": new Date('2020/03/06'),
   "weight": 175.6,
 },
 {
   "date": new Date('2020/03/07'),
   "weight": 175,
 },
 {
   "date": new Date('2020/03/08'),
   "weight": 175,
   "cheatDay": true,
 },
 {
   "date": new Date('2020/03/09'),
   "weight": 178,
 },
 {
   "date": new Date('2020/03/10'),
   "weight": 175.6,
 },
 {
   "date": new Date('2020/03/11'),
   "weight": 175.2,
 },
 {
   "date": new Date('2020/03/12'),
   "weight": 173.8,
 },
 {
   "date": new Date('2020/03/13'),
   "weight": 174,
 },
 {
   "date": new Date('2020/03/14'),
   "weight": 173,
 },
 {
   "date": new Date('2020/03/15'),
   "weight": 172.4,
   "cheatDay": true,
 },
 {
   "date": new Date('2020/03/16'),
   "weight": 175.8,
   "cheatDay": true,
 },
 {
   "date": new Date('2020/03/17'),
   "weight": 177.4,
 },
 {
   "date": new Date('2020/03/18'),
   "weight": 177.2,
 },
 {
   "date": new Date('2020/03/19'),
   "weight": 176.6,
   "cheatDay": true,
 },
 {
   "date": new Date('2020/03/20'),
   "weight": 177.6,
 },
 {
   "date": new Date('2020/03/21'),
   "weight": 176.4,
 },
 {
   "date": new Date('2020/03/22'),
   "weight": 175.4,
   "cheatDay": true,
 },
 {
   "date": new Date('2020/03/23'),
   "weight": 176.6,
   "cheatDay": true,
 },
 {
   "date": new Date('2020/03/24'),
   "weight": 178.8,
 },
 {
   "date": new Date('2020/03/25'),
   "weight": 177,
 },
 {
   "date": new Date('2020/03/26'),
   "weight": 174.4,
   "cheatDay": true,
 },
 {
   "date": new Date('2020/03/27'),
   "weight": 175.8,
 },
 {
   "date": new Date('2020/03/28'),
   "weight": 173,
 },
 {
   "date": new Date('2020/03/29'),
   "weight": 173.6,
 },
 {
   "date": new Date('2020/03/30'),
   "weight": 175.4,
 },
 {
   "date": new Date('2020/03/31'),
   "weight": 174.4,
 },
 {
   "date": new Date('2020/04/01'),
   "weight": 173.6,
 },
 {
   "date": new Date('2020/04/02'),
   "weight": 173.6,
 },
 {
   "date": new Date('2020/04/03'),
   "weight": 173.6,
 },
 {
   "date": new Date('2020/04/04'),
   "weight": 174.8,
   "cheatDay": true,
 },
 {
   "date": new Date('2020/04/05'),
   "weight": 175.4,
 },
 {
   "date": new Date('2020/04/06'),
   "weight": 175,
 },
 {
   "date": new Date('2020/04/07'),
   "weight": 173.2,
 },
 {
   "date": new Date('2020/04/08'),
   "weight": 172.2,
 },
 {
   "date": new Date('2020/04/09'),
   "weight": 171.6,
 },
 {
   "date": new Date('2020/04/10'),
   "weight": 170.6,
   "cheatDay": true,
 },
 {
   "date": new Date('2020/04/11'),
   "weight": 173.4,
   "cheatDay": true,
 },
 {
   "date": new Date('2020/04/12'),
   "weight": 172.4,
   "cheatDay": true,
 },
 {
   "date": new Date('2020/04/13'),
   "weight": 173.6,
 },
 {
   "date": new Date('2020/04/14'),
   "weight": 171.6,
 },
 {
   "date": new Date('2020/04/15'),
   "weight": 170.6,
 },
 {
   "date": new Date('2020/04/16'),
   "weight": 169.8,
   "cheatDay": true,
 },
 {
   "date": new Date('2020/04/17'),
   "weight": 171.2,
   "cheatDay": true,
 },
 {
   "date": new Date('2020/04/18'),
   "weight": 173.6,
   "cheatDay": true,
 },
 {
   "date": new Date('2020/04/19'),
   "weight": 175,
   "cheatDay": true,
 },
 {
   "date": new Date('2020/04/20'),
   "weight": 173,
   "cheatDay": true,
 },
 {
   "date": new Date('2020/04/21'),
   "weight": 173.8,
   "cheatDay": true,
 },
 {
   "date": new Date('2020/04/22'),
   "weight": 174.6,
 },
 {
   "date": new Date('2020/04/23'),
   "weight": 172.4,
 },
 {
   "date": new Date('2020/04/24'),
   "weight": 171.4,
 },
 {
   "date": new Date('2020/04/25'),
   "weight": 170.2,
   "cheatDay": true,
 },
 {
   "date": new Date('2020/04/26'),
   "weight": 170.8,
   "cheatDay": true,
 },
 {
   "date": new Date('2020/04/27'),
   "weight": 171,
 },
 {
   "date": new Date('2020/04/28'),
   "weight": 170.8,
 },
 {
   "date": new Date('2020/04/29'),
   "weight": 170,
 },
 {
   "date": new Date('2020/04/30'),
   "weight": 169.4,
 },
 {
   "date": new Date('2020/05/01'),
   "weight": 169.4,
 },
 {
   "date": new Date('2020/05/02'),
   "weight": 169.2,
 },
 {
   "date": new Date('2020/05/03'),
   "weight": 168.8,
 },
 {
   "date": new Date('2020/05/04'),
   "weight": 169,
 },
 {
   "date": new Date('2020/05/05'),
   "weight": 169.8,
   "cheatDay": true,
 },
 {
   "date": new Date('2020/05/06'),
   "weight": 170.2,
   "cheatDay": true,
 },
 {
   "date": new Date('2020/05/07'),
   "weight": 170.6,
   "cheatDay": true,
 },
 {
   "date": new Date('2020/05/08'),
   "weight": 172.4,
   "cheatDay": true,
 },
 {
   "date": new Date('2020/05/09'),
   "weight": 172.4,
   "cheatDay": true,
 },
 {
   "date": new Date('2020/05/10'),
   "weight": 174,
   "cheatDay": true,
 },
 {
   "date": new Date('2020/05/11'),
   "weight": 175,
   "cheatDay": true,
 },
 {
   "date": new Date('2020/05/12'),
   "weight": 172.6,
   "cheatDay": true,
 },
 {
   "date": new Date('2020/05/13'),
   "weight": 169.8,
   "cheatDay": true,
 },
 {
   "date": new Date('2020/05/14'),
   "weight": 168.8,
   "cheatDay": true,
 },
 {
   "date": new Date('2020/05/15'),
   "weight": 170.8,
   "cheatDay": true,
 },
 {
   "date": new Date('2020/05/16'),
   "weight": 171.2,
   "cheatDay": true,
 },
 {
   "date": new Date('2020/05/17'),
   "weight": 171.4,
   "cheatDay": true,
 },
 {
   "date": new Date('2020/05/18'),
   "weight": 171.6,
   "cheatDay": true,
 },
 {
   "date": new Date('2020/05/19'),
   "weight": 171.6,
   "cheatDay": true,
 },
 {
   "date": new Date('2020/05/20'),
   "weight": 170.8,
   "cheatDay": true,
 },
 {
   "date": new Date('2020/05/21'),
   "weight": 171,
   "cheatDay": true,
 },
 {
   "date": new Date('2020/05/22'),
   "weight": 172.2,
 },
 {
   "date": new Date('2020/05/23'),
   "weight": 171.2,
 },
 {
   "date": new Date('2020/05/24'),
   "weight": 171.6,
 },
 {
   "date": new Date('2020/05/25'),
   "weight": 171.4,
   "cheatDay": true,
 },
 {
   "date": new Date('2020/05/26'),
   "weight": 172.6,
 },
 {
   "date": new Date('2020/05/27'),
   "weight": 171.4,
   "cheatDay": true,
 },
 {
   "date": new Date('2020/05/28'),
   "weight": 171.6,
   "cheatDay": true,
 },
 {
   "date": new Date('2020/05/29'),
   "weight": 172.8,
   "cheatDay": true,
 },
 {
   "date": new Date('2020/05/30'),
   "weight": 172.4,
 },
 {
   "date": new Date('2020/05/31'),
   "weight": 171.6,
 },
 {
   "date": new Date('2020/06/01'),
   "weight": 168.6,
 },
 {
   "date": new Date('2020/06/02'),
   "weight": 169.4,
 },
 {
   "date": new Date('2020/06/03'),
   "weight": 168.8,
 },
 {
   "date": new Date('2020/06/04'),
   "weight": 168.6,
   "cheatDay": true,
 },
 {
   "date": new Date('2020/06/05'),
   "weight": 169.4,
   "cheatDay": true,
 },
 {
   "date": new Date('2020/06/06'),
   "weight": 170.4,
   "cheatDay": true,
 },
 {
   "date": new Date('2020/06/07'),
   "weight": 170.4,
   "cheatDay": true,
 },
 {
   "date": new Date('2020/06/08'),
   "weight": 173.6,
   "cheatDay": true,
 },
 {
   "date": new Date('2020/06/09'),
   "weight": 172.4,
 },
 {
   "date": new Date('2020/06/10'),
   "weight": 170.4,
   "cheatDay": true,
 },
 {
   "date": new Date('2020/06/11'),
   "weight": 170.8,
 },
 {
   "date": new Date('2020/06/12'),
   "weight": 171.6,
   "cheatDay": true,
 },
 {
   "date": new Date('2020/06/13'),
   "weight": 170,
   "cheatDay": true,
 },
 {
   "date": new Date('2020/06/14'),
   "weight": 171.2,
   "cheatDay": true,
 },
 {
   "date": new Date('2020/06/15'),
   "weight": 171.2,
   "cheatDay": true,
 },
 {
   "date": new Date('2020/06/16'),
   "weight": 173,
   "cheatDay": true,
 },
 {
   "date": new Date('2020/06/17'),
   "weight": 171.4,
   "cheatDay": true,
 },
 {
   "date": new Date('2020/06/18'),
   "weight": 169.6,
   "cheatDay": true,
 },
 {
   "date": new Date('2020/06/19'),
   "weight": 170.8,
   "cheatDay": true,
 },
 {
   "date": new Date('2020/06/20'),
   "weight": 170.8,
   "cheatDay": true,
 },
 {
   "date": new Date('2020/06/21'),
   "weight": 172.8,
   "cheatDay": true,
 },
 {
   "date": new Date('2020/06/22'),
   "weight": 172.8,
 },
 {
   "date": new Date('2020/06/23'),
   "weight": 170.2,
 },
 {
   "date": new Date('2020/06/24'),
   "weight": 167.2,
 },
 {
   "date": new Date('2020/06/25'),
   "weight": 167.2,
 },
 {
   "date": new Date('2020/06/26'),
   "weight": 167.2,
 },
 {
   "date": new Date('2020/06/27'),
   "weight": 166,
 },
 {
   "date": new Date('2020/06/28'),
   "weight": 166,
   "cheatDay": true,
 },
 {
   "date": new Date('2020/06/29'),
   "weight": 169.2,
   "cheatDay": true,
 },
 {
   "date": new Date('2020/06/30'),
   "weight": 168,
   "cheatDay": true,
 },
 {
   "date": new Date('2020/07/01'),
   "weight": 168.6,
 },
 {
   "date": new Date('2020/07/02'),
   "weight": 167.8,
 },
 {
   "date": new Date('2020/07/04'),
   "weight": 170.2,
   "cheatDay": true,
 },
 {
   "date": new Date('2020/07/05'),
   "weight": 170.2,
   "cheatDay": true,
 },
 {
   "date": new Date('2020/07/06'),
   "weight": 171.2,
 },
 {
   "date": new Date('2020/07/07'),
   "weight": 167.6,
 },
 {
   "date": new Date('2020/07/08'),
   "weight": 168.8,
 },
 {
   "date": new Date('2020/07/09'),
   "weight": 168,
 },
 {
   "date": new Date('2020/07/10'),
   "weight": 168.2,
   "cheatDay": true,
 },
 {
   "date": new Date('2020/07/11'),
   "weight": 168.4,
 },
 {
   "date": new Date('2020/07/12'),
   "weight": 166.2,
 },
 {
   "date": new Date('2020/07/13'),
   "weight": 168,
   "cheatDay": true,
 },
 {
   "date": new Date('2020/07/14'),
   "weight": 168,
   "cheatDay": true,
 },
 {
   "date": new Date('2020/07/15'),
   "weight": 167.8,
   "cheatDay": true,
 },
 {
   "date": new Date('2020/07/16'),
   "weight": 168.2,
   "cheatDay": true,
 },
 {
   "date": new Date('2020/07/17'),
   "weight": 168.2,
   "cheatDay": true,
 },
 {
   "date": new Date('2020/07/18'),
   "weight": 167.2,
   "cheatDay": true,
 },
 {
   "date": new Date('2020/07/19'),
   "weight": 168.2,
   "cheatDay": true,
 },
 {
   "date": new Date('2020/07/20'),
   "weight": 169.6,
   "cheatDay": true,
 },
 {
   "date": new Date('2020/07/21'),
   "weight": 169.6,
   "cheatDay": true,
 },
 {
   "date": new Date('2020/07/22'),
   "weight": 166.6,
   "cheatDay": true,
 },
 {
   "date": new Date('2020/07/23'),
   "weight": 168,
   "cheatDay": true,
 },
 {
   "date": new Date('2020/07/24'),
   "weight": 170.2,
   "cheatDay": true,
 },
 {
   "date": new Date('2020/07/25'),
   "weight": 168.8,
   "cheatDay": true,
 },
 {
   "date": new Date('2020/07/26'),
   "weight": 168,
   "cheatDay": true,
 },
 {
   "date": new Date('2020/07/27'),
   "weight": 166.6,
   "cheatDay": true,
 },
 {
   "date": new Date('2020/07/28'),
   "weight": 167.4,
   "cheatDay": true,
 },
 {
   "date": new Date('2020/07/29'),
   "weight": 170,
   "cheatDay": true,
 },
 {
   "date": new Date('2020/07/30'),
   "weight": 166.6,
   "cheatDay": true,
 },
 {
   "date": new Date('2020/07/31'),
   "weight": 167.2,
   "cheatDay": true,
 },
 {
   "date": new Date('2020/08/02'),
   "weight": 168,
 },
 {
   "date": new Date('2020/08/03'),
   "weight": 166.2,
   "cheatDay": true,
 },
 {
   "date": new Date('2020/08/04'),
   "weight": 166.4,
   "cheatDay": true,
 },
 {
   "date": new Date('2020/08/05'),
   "weight": 168.6,
 },
 {
   "date": new Date('2020/08/06'),
   "weight": 164.8,
 },
 {
   "date": new Date('2020/08/07'),
   "weight": 166,
   "cheatDay": true,
 },
 {
   "date": new Date('2020/08/08'),
   "weight": 166.8,
   "cheatDay": true,
 },
 {
   "date": new Date('2020/08/09'),
   "weight": 169.2,
   "cheatDay": true,
 },
 {
   "date": new Date('2020/08/10'),
   "weight": 169,
   "cheatDay": true,
 },
 {
   "date": new Date('2020/08/11'),
   "weight": 167.4,
   "cheatDay": true,
 },
 {
   "date": new Date('2020/08/12'),
   "weight": 167.4,
   "cheatDay": true,
 },
 {
   "date": new Date('2020/08/13'),
   "weight": 168,
   "cheatDay": true,
 },
 {
   "date": new Date('2020/08/14'),
   "weight": 169.8,
   "cheatDay": true,
 },
 {
   "date": new Date('2020/08/15'),
   "weight": 171.4,
 },
 {
   "date": new Date('2020/08/22'),
   "weight": 166.4,
   "cheatDay": true,
 },
 {
   "date": new Date('2020/08/25'),
   "weight": 168,
   "cheatDay": true,
 },
 {
   "date": new Date('2020/08/29'),
   "weight": 169.2,
   "cheatDay": true,
 },
 {
   "date": new Date('2020/08/30'),
   "weight": 172.4,
   "cheatDay": true,
 },
 {
   "date": new Date('2020/08/31'),
   "weight": 172.4,
   "cheatDay": true,
 },
 {
   "date": new Date('2020/09/01'),
   "weight": 170,
 },
 {
   "date": new Date('2020/09/02'),
   "weight": 167.8,
   "cheatDay": true,
 },
 {
   "date": new Date('2020/09/03'),
   "weight": 169.2,
   "cheatDay": true,
 },
 {
   "date": new Date('2020/09/04'),
   "weight": 171,
 }
];

const croppedProgPictureFilenames:pictureMapType = {
	//"20190203_085350.jpg-aligned.jpg-cropped.jpg",
	//"20190216_085621.jpg-aligned.jpg-cropped.jpg",
	//"20191003":"20191003_063218.jpg-aligned.jpg-cropped.jpg",
	"20191005": "20191005_062201.jpg-aligned.jpg-cropped.jpg",
	"20191008": "20191008_064127.jpg-aligned.jpg-cropped.jpg",
	"20191010": "20191010_061219.jpg-aligned.jpg-cropped.jpg",
	"20191011": "20191011_062237.jpg-aligned.jpg-cropped.jpg",
	"20191012": "20191012_073130.jpg-aligned.jpg-cropped.jpg",
	"20191013": "20191013_072057.jpg-aligned.jpg-cropped.jpg",
	"20191014": "20191014_072726.jpg-aligned.jpg-cropped.jpg",
	"20191015": "20191015_072437.jpg-aligned.jpg-cropped.jpg",
	"20191016": "20191016_062131.jpg-aligned.jpg-cropped.jpg",
	"20191017": "20191017_062507.jpg-aligned.jpg-cropped.jpg",
	"20191018": "20191018_073856.jpg-aligned.jpg-cropped.jpg",
	"20191019": "20191019_074142.jpg-aligned.jpg-cropped.jpg",
	"20191020": "20191020_065426.jpg-aligned.jpg-cropped.jpg",
	"20191021": "20191021_073010.jpg-aligned.jpg-cropped.jpg",
	"20191022": "20191022_061840.jpg-aligned.jpg-cropped.jpg",
	"20191023": "20191023_062326.jpg-aligned.jpg-cropped.jpg",
	"20191024": "20191024_062330.jpg-aligned.jpg-cropped.jpg",
	"20191025": "20191025_062850.jpg-aligned.jpg-cropped.jpg",
	"20191026": "20191026_070513.jpg-aligned.jpg-cropped.jpg",
	"20191027": "20191027_063942.jpg-aligned.jpg-cropped.jpg",
	"20191028": "20191028_063543.jpg-aligned.jpg-cropped.jpg",
	"20191029": "20191029_061905.jpg-aligned.jpg-cropped.jpg",
	"20191030": "20191030_062543.jpg-aligned.jpg-cropped.jpg",
	"20191031": "20191031_062811.jpg-aligned.jpg-cropped.jpg",
	"20191101": "20191101_061933.jpg-aligned.jpg-cropped.jpg",
	"20191102": "20191102_090434.jpg-aligned.jpg-cropped.jpg",
	"20191103": "20191103_054802.jpg-aligned.jpg-cropped.jpg",
	"20191104": "20191104_064218.jpg-aligned.jpg-cropped.jpg",
	"20191105": "20191105_062231.jpg-aligned.jpg-cropped.jpg",
	"20191106": "20191106_063044.jpg-aligned.jpg-cropped.jpg",
	"20191107": "20191107_062325.jpg-aligned.jpg-cropped.jpg",
	"20191108": "20191108_062041.jpg-aligned.jpg-cropped.jpg",
	"20191109": "20191109_073016.jpg-aligned.jpg-cropped.jpg",
	"20191110": "20191110_072435.jpg-aligned.jpg-cropped.jpg",
	"20191111": "20191111_074339.jpg-aligned.jpg-cropped.jpg",
	"20191112": "20191112_074540.jpg-aligned.jpg-cropped.jpg",
	"20191113": "20191113_062215.jpg-aligned.jpg-cropped.jpg",
	"20191114": "20191114_063016.jpg-aligned.jpg-cropped.jpg",
	"20191115": "20191115_062741.jpg-aligned.jpg-cropped.jpg",
	"20191116": "20191116_064943.jpg-aligned.jpg-cropped.jpg",
	"20191117": "20191117_080431.jpg-aligned.jpg-cropped.jpg",
	"20191118": "20191118_073903.jpg-aligned.jpg-cropped.jpg",
	"20191119": "20191119_061840.jpg-aligned.jpg-cropped.jpg",
	"20191120": "20191120_062504.jpg-aligned.jpg-cropped.jpg",
	"20191121": "20191121_062504.jpg-aligned.jpg-cropped.jpg",
	"20191122": "20191122_084743.jpg-aligned.jpg-cropped.jpg",
	"20191123": "20191123_070108.jpg-aligned.jpg-cropped.jpg",
	"20191124": "20191124_194426.jpg-aligned.jpg-cropped.jpg",
	"20191125": "20191125_071145.jpg-aligned.jpg-cropped.jpg",
	"20191126": "20191126_063452.jpg-aligned.jpg-cropped.jpg",
	"20191127": "20191127_063726.jpg-aligned.jpg-cropped.jpg",
	"20191128": "20191128_073810.jpg-aligned.jpg-cropped.jpg",
	"20191129": "20191129_082218.jpg-aligned.jpg-cropped.jpg",
	"20191130": "20191130_074250.jpg-aligned.jpg-cropped.jpg",
	"20191201": "20191201_062733.jpg-aligned.jpg-cropped.jpg",
	"20191202": "20191202_081819.jpg-aligned.jpg-cropped.jpg",
	"20191203": "20191203_062406.jpg-aligned.jpg-cropped.jpg",
	"20191204": "20191204_062251.jpg-aligned.jpg-cropped.jpg",
	"20191205": "20191205_062041.jpg-aligned.jpg-cropped.jpg",
	"20191206": "20191206_062217.jpg-aligned.jpg-cropped.jpg",
	"20191207": "20191207_064801.jpg-aligned.jpg-cropped.jpg",
	"20191208": "20191208_074507.jpg-aligned.jpg-cropped.jpg",
	"20191209": "20191209_071706.jpg-aligned.jpg-cropped.jpg",
	"20191210": "20191210_062000.jpg-aligned.jpg-cropped.jpg",
	"20191211": "20191211_061852.jpg-aligned.jpg-cropped.jpg",
	"20191212": "20191212_062415.jpg-aligned.jpg-cropped.jpg",
	"20191213": "20191213_062235.jpg-aligned.jpg-cropped.jpg",
	"20191214": "20191214_071920.jpg-aligned.jpg-cropped.jpg",
	"20191215": "20191215_095718.jpg-aligned.jpg-cropped.jpg",
	"20191216": "20191216_065203.jpg-aligned.jpg-cropped.jpg",
	"20191217": "20191217_062258.jpg-aligned.jpg-cropped.jpg",
	"20191218": "20191218_062446.jpg-aligned.jpg-cropped.jpg",
	"20191219": "20191219_062305.jpg-aligned.jpg-cropped.jpg",
	"20191220": "20191220_062813.jpg-aligned.jpg-cropped.jpg",
	"20191221": "20191221_081052.jpg-aligned.jpg-cropped.jpg",
	"20191222": "20191222_083743.jpg-aligned.jpg-cropped.jpg",
	"20191223": "20191223_074935.jpg-aligned.jpg-cropped.jpg",
	"20191224": "20191224_073223.jpg-aligned.jpg-cropped.jpg",
	"20191225": "20191225_090335.jpg-aligned.jpg-cropped.jpg",
	"20191226": "20191226_081008.jpg-aligned.jpg-cropped.jpg",
	"20191227": "20191227_072624.jpg-aligned.jpg-cropped.jpg",
	"20191228": "20191228_075638.jpg-aligned.jpg-cropped.jpg",
	"20191229": "20191229_071349.jpg-aligned.jpg-cropped.jpg",
	"20191230": "20191230_063048.jpg-aligned.jpg-cropped.jpg",
	"20191231": "20191231_075134.jpg-aligned.jpg-cropped.jpg",
	"20200101": "20200101_084540.jpg-aligned.jpg-cropped.jpg",
	"20200102": "20200102_073913.jpg-aligned.jpg-cropped.jpg",
	"20200103": "20200103_062421.jpg-aligned.jpg-cropped.jpg",
	"20200104": "20200104_084647.jpg-aligned.jpg-cropped.jpg",
	"20200105": "20200105_153504.jpg-aligned.jpg-cropped.jpg",
	"20200106": "20200106_071819.jpg-aligned.jpg-cropped.jpg",
	"20200107": "20200107_062430.jpg-aligned.jpg-cropped.jpg",
	"20200108": "20200108_062423.jpg-aligned.jpg-cropped.jpg",
	"20200109": "20200109_062627.jpg-aligned.jpg-cropped.jpg",
	"20200110": "20200110_061832.jpg-aligned.jpg-cropped.jpg",
	"20200111": "20200111_073105.jpg-aligned.jpg-cropped.jpg",
	"20200112": "20200112_074015.jpg-aligned.jpg-cropped.jpg",
	"20200113": "20200113_072032.jpg-aligned.jpg-cropped.jpg",
	"20200114": "20200114_062510.jpg-aligned.jpg-cropped.jpg",
	"20200115": "20200115_060635.jpg-aligned.jpg-cropped.jpg",
	"20200116": "20200116_061602.jpg-aligned.jpg-cropped.jpg",
	"20200117": "20200117_062011.jpg-aligned.jpg-cropped.jpg",
	"20200118": "20200118_074343.jpg-aligned.jpg-cropped.jpg",
	"20200119": "20200119_180329.jpg-aligned.jpg-cropped.jpg",
	"20200120": "20200120_070657.jpg-aligned.jpg-cropped.jpg",
	"20200121": "20200121_065510.jpg-aligned.jpg-cropped.jpg",
	"20200122": "20200122_062101.jpg-aligned.jpg-cropped.jpg",
	"20200123": "20200123_061912.jpg-aligned.jpg-cropped.jpg",
	"20200124": "20200124_062537.jpg-aligned.jpg-cropped.jpg",
	"20200125": "20200125_062740.jpg-aligned.jpg-cropped.jpg",
	"20200126": "20200126_064447.jpg-aligned.jpg-cropped.jpg",
	"20200127": "20200127_071403.jpg-aligned.jpg-cropped.jpg",
	"20200128": "20200128_062142.jpg-aligned.jpg-cropped.jpg",
	"20200129": "20200129_062009.jpg-aligned.jpg-cropped.jpg",
	"20200130": "20200130_062230.jpg-aligned.jpg-cropped.jpg",
	"20200131": "20200131_060415.jpg-aligned.jpg-cropped.jpg",
	"20200201": "20200201_060216.jpg-aligned.jpg-cropped.jpg",
	"20200202": "20200202_063241.jpg-aligned.jpg-cropped.jpg",
	"20200203": "20200203_064935.jpg-aligned.jpg-cropped.jpg",
	"20200204": "20200204_062416.jpg-aligned.jpg-cropped.jpg",
	"20200205": "20200205_061642.jpg-aligned.jpg-cropped.jpg",
	"20200206": "20200206_063014.jpg-aligned.jpg-cropped.jpg",
	"20200207": "20200207_061637.jpg-aligned.jpg-cropped.jpg",
	"20200208": "20200208_062255.jpg-aligned.jpg-cropped.jpg",
	"20200209": "20200209_075705.jpg-aligned.jpg-cropped.jpg",
	"20200210": "20200210_074423.jpg-aligned.jpg-cropped.jpg",
	"20200211": "20200211_061825.jpg-aligned.jpg-cropped.jpg",
	"20200212": "20200212_061742.jpg-aligned.jpg-cropped.jpg",
	"20200213": "20200213_062157.jpg-aligned.jpg-cropped.jpg",
	"20200214": "20200214_062246.jpg-aligned.jpg-cropped.jpg",
	"20200215": "20200215_071852.jpg-aligned.jpg-cropped.jpg",
	"20200216": "20200216_073759.jpg-aligned.jpg-cropped.jpg",
	"20200217": "20200217_065116.jpg-aligned.jpg-cropped.jpg",
	"20200218": "20200218_070409.jpg-aligned.jpg-cropped.jpg",
	"20200219": "20200219_061528.jpg-aligned.jpg-cropped.jpg",
	"20200220": "20200220_061822.jpg-aligned.jpg-cropped.jpg",
	"20200221": "20200221_062457.jpg-aligned.jpg-cropped.jpg",
	"20200222": "20200222_072117.jpg-aligned.jpg-cropped.jpg",
	"20200223": "20200223_143336.jpg-aligned.jpg-cropped.jpg",
	"20200224": "20200224_070015.jpg-aligned.jpg-cropped.jpg",
	"20200225": "20200225_061657.jpg-aligned.jpg-cropped.jpg",
	"20200226": "20200226_062302.jpg-aligned.jpg-cropped.jpg",
	"20200227": "20200227_062348.jpg-aligned.jpg-cropped.jpg",
	"20200228": "20200228_062332.jpg-aligned.jpg-cropped.jpg",
	"20200229": "20200229_060259.jpg-aligned.jpg-cropped.jpg",
	"20200301": "20200301_075359.jpg-aligned.jpg-cropped.jpg",
	"20200302": "20200302_064959.jpg-aligned.jpg-cropped.jpg",
	"20200303": "20200303_061258.jpg-aligned.jpg-cropped.jpg",
	"20200304": "20200304_061741.jpg-aligned.jpg-cropped.jpg",
	"20200305": "20200305_062128.jpg-aligned.jpg-cropped.jpg",
	"20200306": "20200306_061600.jpg-aligned.jpg-cropped.jpg",
	"20200307": "20200307_061406.jpg-aligned.jpg-cropped.jpg",
	"20200308": "20200308_080654.jpg-aligned.jpg-cropped.jpg",
	"20200309": "20200309_075845.jpg-aligned.jpg-cropped.jpg",
	"20200310": "20200310_062149.jpg-aligned.jpg-cropped.jpg",
	"20200311": "20200311_062503.jpg-aligned.jpg-cropped.jpg",
	"20200312": "20200312_064052.jpg-aligned.jpg-cropped.jpg",
	"20200313": "20200313_073223.jpg-aligned.jpg-cropped.jpg",
	"20200314": "20200314_081152.jpg-aligned.jpg-cropped.jpg",
	"20200315": "20200315_131646.jpg-aligned.jpg-cropped.jpg",
	"20200316": "20200316_075223.jpg-aligned.jpg-cropped.jpg",
	"20200317": "20200317_070920.jpg-aligned.jpg-cropped.jpg",
	"20200318": "20200318_081115.jpg-aligned.jpg-cropped.jpg",
	"20200319": "20200319_071835.jpg-aligned.jpg-cropped.jpg",
	"20200320": "20200320_075032.jpg-aligned.jpg-cropped.jpg",
	"20200321": "20200321_080630.jpg-aligned.jpg-cropped.jpg",
	"20200322": "20200322_075227.jpg-aligned.jpg-cropped.jpg",
	"20200323": "20200323_072436.jpg-aligned.jpg-cropped.jpg",
	"20200324": "20200324_071942.jpg-aligned.jpg-cropped.jpg",
	"20200325": "20200325_073950.jpg-aligned.jpg-cropped.jpg",
	"20200326": "20200326_081457.jpg-aligned.jpg-cropped.jpg",
	"20200327": "20200327_064859.jpg-aligned.jpg-cropped.jpg",
	"20200328": "20200328_113122.jpg-aligned.jpg-cropped.jpg",
	"20200329": "20200329_091650.jpg-aligned.jpg-cropped.jpg",
	"20200330": "20200330_080701.jpg-aligned.jpg-cropped.jpg",
	"20200331": "20200331_074701.jpg-aligned.jpg-cropped.jpg",
	"20200401": "20200401_071858.jpg-aligned.jpg-cropped.jpg",
	"20200402": "20200402_072418.jpg-aligned.jpg-cropped.jpg",
	"20200403": "20200403_075510.jpg-aligned.jpg-cropped.jpg",
	"20200404": "20200404_082016.jpg-aligned.jpg-cropped.jpg",
	"20200405": "20200405_075125.jpg-aligned.jpg-cropped.jpg",
	"20200406": "20200406_072343.jpg-aligned.jpg-cropped.jpg",
	"20200407": "20200407_073919.jpg-aligned.jpg-cropped.jpg",
	"20200408": "20200408_073423.jpg-aligned.jpg-cropped.jpg",
	"20200409": "20200409_084755.jpg-aligned.jpg-cropped.jpg",
	"20200410": "20200410_075131.jpg-aligned.jpg-cropped.jpg",
	"20200411": "20200411_064446.jpg-aligned.jpg-cropped.jpg",
	"20200412": "20200412_080342.jpg-aligned.jpg-cropped.jpg",
	"20200413": "20200413_100233.jpg-aligned.jpg-cropped.jpg",
	"20200414": "20200414_083056.jpg-aligned.jpg-cropped.jpg",
	"20200415": "20200415_074625.jpg-aligned.jpg-cropped.jpg",
	"20200416": "20200416_084057.jpg-aligned.jpg-cropped.jpg",
	"20200417": "20200417_073056.jpg-aligned.jpg-cropped.jpg",
	"20200418": "20200418_081358.jpg-aligned.jpg-cropped.jpg",
	"20200419": "20200419_074118.jpg-aligned.jpg-cropped.jpg",
	"20200420": "20200420_083102.jpg-aligned.jpg-cropped.jpg",
	"20200421": "20200421_073657.jpg-aligned.jpg-cropped.jpg",
	"20200422": "20200422_071701.jpg-aligned.jpg-cropped.jpg",
	"20200423": "20200423_090456.jpg-aligned.jpg-cropped.jpg",
	"20200424": "20200424_074344.jpg-aligned.jpg-cropped.jpg",
	"20200425": "20200425_081814.jpg-aligned.jpg-cropped.jpg",
	"20200426": "20200426_075325.jpg-aligned.jpg-cropped.jpg",
	"20200427": "20200427_072948.jpg-aligned.jpg-cropped.jpg",
	"20200428": "20200428_080623.jpg-aligned.jpg-cropped.jpg",
	"20200429": "20200429_065406.jpg-aligned.jpg-cropped.jpg",
	"20200430": "20200430_072646.jpg-aligned.jpg-cropped.jpg",
	"20200501": "20200501_092342.jpg-aligned.jpg-cropped.jpg",
	"20200502": "20200502_062104.jpg-aligned.jpg-cropped.jpg",
	"20200503": "20200503_072732.jpg-aligned.jpg-cropped.jpg",
	"20200504": "20200504_074206.jpg-aligned.jpg-cropped.jpg",
	"20200505": "20200505_161810.jpg-aligned.jpg-cropped.jpg",
	"20200506": "20200506_073931.jpg-aligned.jpg-cropped.jpg",
	"20200507": "20200507_081252.jpg-aligned.jpg-cropped.jpg",
	"20200508": "20200508_071106.jpg-aligned.jpg-cropped.jpg",
	"20200509": "20200509_081640.jpg-aligned.jpg-cropped.jpg",
	"20200510": "20200510_070148.jpg-aligned.jpg-cropped.jpg",
	"20200511": "20200511_071546.jpg-aligned.jpg-cropped.jpg",
	"20200512": "20200512_070856.jpg-aligned.jpg-cropped.jpg",
	"20200513": "20200513_081000.jpg-aligned.jpg-cropped.jpg",
	"20200514": "20200514_074237.jpg-aligned.jpg-cropped.jpg",
	"20200515": "20200515_073043.jpg-aligned.jpg-cropped.jpg",
	"20200516": "20200516_074156.jpg-aligned.jpg-cropped.jpg",
	"20200517": "20200517_110036.jpg-aligned.jpg-cropped.jpg",
	"20200518": "20200518_075532.jpg-aligned.jpg-cropped.jpg",
	"20200519": "20200519_074108.jpg-aligned.jpg-cropped.jpg",
	"20200520": "20200520_075507.jpg-aligned.jpg-cropped.jpg",
	"20200521": "20200521_072941.jpg-aligned.jpg-cropped.jpg",
	"20200522": "20200522_082957.jpg-aligned.jpg-cropped.jpg",
	"20200523": "20200523_085013.jpg-aligned.jpg-cropped.jpg",
	"20200524": "20200524_071447.jpg-aligned.jpg-cropped.jpg",
	"20200525": "20200525_101017.jpg-aligned.jpg-cropped.jpg",
	"20200526": "20200526_072854.jpg-aligned.jpg-cropped.jpg",
	"20200527": "20200527_074442.jpg-aligned.jpg-cropped.jpg",
	"20200528": "20200528_073230.jpg-aligned.jpg-cropped.jpg",
	"20200529": "20200529_075215.jpg-aligned.jpg-cropped.jpg",
	"20200530": "20200530_085021.jpg-aligned.jpg-cropped.jpg",
	"20200531": "20200531_063937.jpg-aligned.jpg-cropped.jpg",
	"20200601": "20200601_094344.jpg-aligned.jpg-cropped.jpg",
	"20200602": "20200602_073434.jpg-aligned.jpg-cropped.jpg",
	"20200603": "20200603_074000.jpg-aligned.jpg-cropped.jpg",
	"20200604": "20200604_081909.jpg-aligned.jpg-cropped.jpg",
	"20200605": "20200605_074339.jpg-aligned.jpg-cropped.jpg",
	"20200606": "20200606_081523.jpg-aligned.jpg-cropped.jpg",
	"20200607": "20200607_064728.jpg-aligned.jpg-cropped.jpg",
	"20200608": "20200608_063507.jpg-aligned.jpg-cropped.jpg",
	"20200609": "20200609_072041.jpg-aligned.jpg-cropped.jpg",
	"20200610": "20200610_071338.jpg-aligned.jpg-cropped.jpg",
	"20200611": "20200611_070124.jpg-aligned.jpg-cropped.jpg",
	"20200612": "20200612_063704.jpg-aligned.jpg-cropped.jpg",
	"20200613": "20200613_064102.jpg-aligned.jpg-cropped.jpg",
	"20200614": "20200614_075743.jpg-aligned.jpg-cropped.jpg",
	"20200615": "20200615_072433.jpg-aligned.jpg-cropped.jpg",
	"20200616": "20200616_072718.jpg-aligned.jpg-cropped.jpg",
	"20200617": "20200617_071133.jpg-aligned.jpg-cropped.jpg",
	"20200618": "20200618_071058.jpg-aligned.jpg-cropped.jpg",
	"20200619": "20200619_070728.jpg-aligned.jpg-cropped.jpg",
	"20200620": "20200620_070616.jpg-aligned.jpg-cropped.jpg",
	"20200621": "20200621_094912.jpg-aligned.jpg-cropped.jpg",
	"20200622": "20200622_072619.jpg-aligned.jpg-cropped.jpg",
	"20200623": "20200623_225449.jpg-aligned.jpg-cropped.jpg",
	"20200624": "20200624_131502.jpg-aligned.jpg-cropped.jpg",
	"20200625": "20200625_065420.jpg-aligned.jpg-cropped.jpg",
	"20200626": "20200626_065426.jpg-aligned.jpg-cropped.jpg",
	"20200627": "20200627_093502.jpg-aligned.jpg-cropped.jpg",
	"20200628": "20200628_061606.jpg-aligned.jpg-cropped.jpg",
	"20200629": "20200629_103523.jpg-aligned.jpg-cropped.jpg",
	"20200630": "20200630_071031.jpg-aligned.jpg-cropped.jpg",
	"20200701": "20200701_072920.jpg-aligned.jpg-cropped.jpg",
	"20200702": "20200702_063740.jpg-aligned.jpg-cropped.jpg",
	"20200704": "20200704_173756.jpg-aligned.jpg-cropped.jpg",
	"20200705": "20200705_063213.jpg-aligned.jpg-cropped.jpg",
	"20200706": "20200706_060010.jpg-aligned.jpg-cropped.jpg",
	"20200707": "20200707_072043.jpg-aligned.jpg-cropped.jpg",
	"20200708": "20200708_064756.jpg-aligned.jpg-cropped.jpg",
	"20200709": "20200709_062546.jpg-aligned.jpg-cropped.jpg",
	"20200710": "20200710_142754.jpg-aligned.jpg-cropped.jpg",
	"20200711": "20200711_055808.jpg-aligned.jpg-cropped.jpg",
	"20200712": "20200712_070211.jpg-aligned.jpg-cropped.jpg",
	"20200713": "20200713_072453.jpg-aligned.jpg-cropped.jpg",
	"20200714": "20200714_075047.jpg-aligned.jpg-cropped.jpg",
	"20200715": "20200715_070845.jpg-aligned.jpg-cropped.jpg",
	"20200716": "20200716_070751.jpg-aligned.jpg-cropped.jpg",
	"20200717": "20200717_070640.jpg-aligned.jpg-cropped.jpg",
	"20200718": "20200718_081227.jpg-aligned.jpg-cropped.jpg",
	"20200719": "20200719_075802.jpg-aligned.jpg-cropped.jpg",
	"20200720": "20200720_073056.jpg-aligned.jpg-cropped.jpg",
	"20200721": "20200721_062733.jpg-aligned.jpg-cropped.jpg",
	"20200722": "20200722_072814.jpg-aligned.jpg-cropped.jpg",
	"20200723": "20200723_075212.jpg-aligned.jpg-cropped.jpg",
	"20200724": "20200724_070937.jpg-aligned.jpg-cropped.jpg",
	"20200725": "20200725_065803.jpg-aligned.jpg-cropped.jpg",
	"20200726": "20200726_070046.jpg-aligned.jpg-cropped.jpg",
	"20200727": "20200727_075508.jpg-aligned.jpg-cropped.jpg",
	"20200728": "20200728_073900.jpg-aligned.jpg-cropped.jpg",
	"20200729": "20200729_075556.jpg-aligned.jpg-cropped.jpg",
	"20200730": "20200730_100607.jpg-aligned.jpg-cropped.jpg",
	"20200731": "20200731_081359.jpg-aligned.jpg-cropped.jpg",
	"20200802": "20200802_071141.jpg-aligned.jpg-cropped.jpg",
	"20200803": "20200803_065714.jpg-aligned.jpg-cropped.jpg",
	"20200804": "20200804_080546.jpg-aligned.jpg-cropped.jpg",
	"20200805": "20200805_070434.jpg-aligned.jpg-cropped.jpg",
	"20200806": "20200806_073531.jpg-aligned.jpg-cropped.jpg",
	"20200807": "20200807_110226.jpg-aligned.jpg-cropped.jpg",
	"20200808": "20200808_064123.jpg-aligned.jpg-cropped.jpg",
	"20200809": "20200809_072516.jpg-aligned.jpg-cropped.jpg",
	"20200810": "20200810_085010.jpg-aligned.jpg-cropped.jpg",
	"20200811": "20200811_160456.jpg-aligned.jpg-cropped.jpg",
	"20200812": "20200812_080548.jpg-aligned.jpg-cropped.jpg",
	"20200813": "20200813_072115.jpg-aligned.jpg-cropped.jpg",
	"20200814": "20200814_074829.jpg-aligned.jpg-cropped.jpg",
	"20200815": "20200815_080458.jpg-aligned.jpg-cropped.jpg",
	"20200822": "20200822_180737.jpg-aligned.jpg-cropped.jpg",
	"20200825": "20200825_082435.jpg-aligned.jpg-cropped.jpg",
	"20200829": "20200829_073356.jpg-aligned.jpg-cropped.jpg",
	"20200830": "20200830_070624.jpg-aligned.jpg-cropped.jpg",
	"20200831": "20200831_083754.jpg-aligned.jpg-cropped.jpg",
	"20200901": "20200901_114747.jpg-aligned.jpg-cropped.jpg",
	"20200902": "20200902_083218.jpg-aligned.jpg-cropped.jpg",
	"20200903": "20200903_090846.jpg-aligned.jpg-cropped.jpg",
	"20200904": "20200904_080413.jpg-aligned.jpg-cropped.jpg"
};

export { wlProgressData, croppedProgPictureFilenames };

export type { wlProgressDataMemberType, pictureMapType };
